import { KLYDO_BLACK, KLYDO_WHITE } from '../../../consts/colors';
import { TABLET } from '../../../consts/breakpoints';
import DSBox from '../../../design-system/DSBox';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import useAuthPage from '../hooks/useAuthPage';
import AuthForm from './AuthForm';
import Headline from './Headline';

const AuthPage = () => {
  const auth = useAuthPage();
  const { width } = useWindowDimensions();
  const isMobile = width <= TABLET;

  return (
    <DSBox
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: KLYDO_BLACK,
        color: KLYDO_WHITE,
        gap: 2,
        p: 3,
      }}
    >
      <AuthForm
        auth={auth}
        logoWidth={isMobile ? 160 : 200}
        headline={
          <DSBox sx={{ mb: 1 }}>
            {isMobile && <Headline mobile={true} desktopAlign="center" />}
          </DSBox>
        }
      />
    </DSBox>
  );
};

export default AuthPage;
